import React, { Component } from 'react'
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArrayForOption, convertStringToArrayForRadio } from '../../../../../utils';
// restClient
import { aemHostClient, taxonomyHostClient } from '../../../../../restClient';
// children
import BalanceTiers from './BalanceTiers/';
import IETierPicker from '../IETierPicker';
import SimpleDropdown from '../../../../common/SimpleDropdown';
//action Creator
import { setInterestEnhancementCurrency, setDeletedtTierIndex } from './../../../../CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/actions/actionCreator'
//style
import './style.css'
import { _tierSett, _interestEnhancement } from "./../Dummy/accounts"

class IETireSetting extends Component {
  constructor(props) {
    super(props);
    this.balanceTierLabels = [];
    this.state = {
      baseCurrency: [],
      selectedCurrency: '',
      poolPositionRule: [],
      selectedPoolPositionRule: '',
      tireData: [{
        balanceForEnhancementMargin: '',
        balanceEligibleAccountsForPremiumMargin: ''
      }],
      settlementDate: {},
      tierSettingsJson: []
    }
    this.mode = typeof this.props.location !== 'undefined' ? this.props.location.state.mode !== null && this.props.location.state.mode !== undefined ? 'edit' : 'add' : 'add';
    this.payload = new IETireAndSettingsPayload(this.mode);
    this.dataDictionaryURI = '';
    this.currencyURI = `/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:AllCurrency`;
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  componentWillMount() {
    taxonomyHostClient(this.currencyURI)
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          this.props.setInterestEnhancementCurrency(data.responseData);
          this.setState({
            baseCurrency: data.responseData.classificationNodes
          });
        }
      });
    this.props.data && this.payload.setIdAndLogicalIdParent(this.props.data);
    if (typeof this.props.interestEnhancement.tierSettings !== 'undefined') {
      this.mode = 'edit';
      let _state = this.state;
      const { baseCurrency, poolPositionRule, tiers, settlementDate } = this.props.interestEnhancement.tierSettings;
      // let id = this.props.location.state.id;
      // let lid = this.props.location.state.lid;
      _state['tireData'] = tiers;
      _state['selectedCurrency'] = typeof baseCurrency !== 'undefined' ? baseCurrency.value : '';
      _state['settlementDate'] = typeof settlementDate !== 'undefined' ? settlementDate : '';
      _state['selectedPoolPositionRule'] = typeof poolPositionRule !== 'undefined' ? poolPositionRule.value : 'netAggregate';

      if (typeof poolPositionRule === 'undefined') {
        var _customObj = {
          name: 'poolPositionRule',
          value: {
            id: 'netAggregate',
            name: 'Net Aggregate',
            value: 'netAggregate'
          }
        }
        this.payload.setPayload(_customObj);
        this.props.IETireSettingData(this.payload.getPayload());
      }
      if (typeof settlementDate === 'undefined') {
        var customObjsettlementDate = {
          name: 'settlementDate',
          value: {
            frequencyType: {
              name: "Monthly",
              value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
            },
            frequencyDetails: {
              name: "",
              value: ""
            }
          }
        }
        this.payload.setPayload(customObjsettlementDate);
        this.props.IETireSettingData(this.payload.getPayload());
      }
      this.setState(_state);
      //this.payload.setIdAndLogicalIdChild(id , lid);
    }

    aemHostClient("/aemData/formData/json_sow-interest-enhancement-tiers-settings-form")
      .then(({ data }) => {
        this.setState({
          tierSettingsJson: data.guideContainer.rootPanel.items,
        });
        this.setPoolOptions();
      });

    this.dataDictionaryURI = this.props.dataDictionaryURI;
  }

  setPoolOptions = () => {
    if (this.state.tierSettingsJson !== undefined && this.state.tierSettingsJson.length !== 0) {
      let poolSideOption = this.translateWord(this.state.tierSettingsJson.guidedropdownlist_poolPositionRule.options);
      let poolOptions = poolSideOption.map(item => {
        return {
          name: item.split('=')[1],
          id: item.split('=')[0],
          lid: item.split('=')[0],
          description: item.split('=')[1],
        }
      });
      this.setState({ poolPositionRule: poolOptions })
    }
  }

  componentWillReceiveProps(nextProps) {
    this.payload.setIdAndLogicalIdParent(this.props.data);
    this.setPoolOptions();
  }

  deletedTierIndex = (data) => {
    this.props.setDeletedtTierIndex(data)
  }
  getData = (data) => {
    let customObj = {}
    if (typeof data.target !== 'undefined') {
      if (data.target.name === 'baseCurrency') {
        var currency = data.target.value.split(':');
        var currVal = currency[currency.length - 1]
        customObj = {
          name: data.target.name,
          value: {
            id: data.target.value,
            name: currVal,
            value: data.target.value
          }
        }
        this.setState({
          selectedCurrency: data.target.value
        })
      }
      if (data.target.name === 'poolPositionRule') {
        let setpoolPositionRuleName;
        this.state.poolPositionRule.filter(item => {
          if (item.id === data.target.value) {
            setpoolPositionRuleName = item.description
          }
        });
        customObj = {
          name: data.target.name,
          value: {
            id: data.target.value,
            name: setpoolPositionRuleName,
            value: data.target.value
          }
        }
        this.setState({
          selectedPoolPositionRule: data.target.value
        });
      }
    } else {
      if (typeof data.length !== 'undefined') {
        customObj = {
          name: 'tiers',
          value: data
        }
      } else {
        customObj = {
          name: 'settlementDate',
          value: data
        }
      }
    }
    this.payload.setPayload(customObj);
    this.props.IETireSettingData(this.payload.getPayload());

  }

  render() {
    const names = "Interest period";
    const fieldPrefix = "text7";

    if (this.props.premiumMargin && this.state.tierSettingsJson !== undefined && this.state.tierSettingsJson.length !== 0 && this.state.tierSettingsJson.guideinterestcombobo_tiers.subLabels.length !== 0) {
      this.balanceTierLabels = this.translateWord(this.state.tierSettingsJson.guideinterestcombobo_tiers.subLabels)
    } else if (this.state.tierSettingsJson !== undefined && this.state.tierSettingsJson.length !== 0 && this.state.tierSettingsJson.guideinterestcombobo_tiers.subLabels.length !== 0) {
      this.balanceTierLabels = this.translateWord(this.state.tierSettingsJson.guideinterestcombobo_tiers.subLabels)[0]
    }

    return (
      (this.state.tierSettingsJson !== undefined && this.state.tierSettingsJson.length !== 0 ?
        <div className="gdoc-ieTierContainer">
          <div className="base-currency">
            <label>{this.translations(this.state.tierSettingsJson.guidedropdownlist_baseCurrency.title)}</label>
            <SimpleDropdown
              name="baseCurrency"
              disabled={this.props.customer.roleDetails.customer}
              defaultValue={this.translations(this.state.tierSettingsJson.guidedropdownlist_poolPositionRule._value)}
              value={this.state.selectedCurrency}
              options={this.state.baseCurrency || []}
              optionTextSelector={"description"}
              _onChange={this.getData}
            />
          </div>

          <div className="base-currency">
            <label>{this.translations(this.state.tierSettingsJson.guidedropdownlist_poolPositionRule.title)}</label>
            <SimpleDropdown
              name="poolPositionRule"
              disabled={this.props.customer.roleDetails.customer}
              value={this.state.selectedPoolPositionRule}
              options={this.state.poolPositionRule || []}
              optionTextSelector={"description"}
              _onChange={this.getData}
              showPleaseSelectOption={false}
            />
            <p>{this.translations(this.state.tierSettingsJson.guidedropdownlist_poolPositionRule.helpText)} </p>
          </div>
          <BalanceTiers
            disabled={this.props.customer.roleDetails.customer}
            boxLabel={this.translations(this.state.tierSettingsJson.guideinterestcombobo_tiers.boxLabel)}
            maxChars={this.state.tierSettingsJson.guideinterestcombobo_tiers.maxChars}
            sectionLabel={this.translations(this.state.tierSettingsJson.guideinterestcombobo_tiers.sectionLabel)}
            subLabels={this.translateWord(this.state.tierSettingsJson.guideinterestcombobo_tiers.subLabels)}
            premiumVal={this.props.premiumMargin}
            addBtnText={this.translations(this.state.tierSettingsJson.guideinterestcombobo_tiers.btnText)}
            data={this.props.data.interestEnhancement.tierSettings.tiers}
            _tireData={this.getData}
            _deletedTierIndex={this.deletedTierIndex}
          />
          <div className="gdocs-clear-float"></div>
          <div key="buttons-wrapper" className="form-buttons-save-section">
            <div className="form-buttons-wrapper">
              <button
                className="gdocs-btn-submit"
                onClick={this.props.ieTireSettingTabData}
              >{this.translations(this.state.tierSettingsJson.guidebutton_save.text)}</button>
            </div>
          </div>
        </div>
        : 'No Data'));
  }

}
class IETireAndSettingsPayload {
  constructor(mode) {
    this.mode = mode;
    this.data = {};
    this.tierSettings = {};
  }
  setIdAndLogicalIdParent(props) {
    this.data.id = props.id;
    this.data.lid = props.lid;
  }
  setIdAndLogicalIdChild(id = null, lid = null) {
    if (this.mode === 'edit') {
      this.tierSettings.id = id;
      this.tierSettings.lid = id
    }
  }
  setPayload(data) {
    switch (data.name) {
      case "baseCurrency":
        this.tierSettings.baseCurrency = data.value;
        break;
      case "settlementDate":
        this.tierSettings.settlementDate = data.value;
        break;
      case "poolPositionRule":
        this.tierSettings.poolPositionRule = data.value;
        break;
      case "tiers":
        this.tierSettings.tiers = data.value;
        break;
      default:
        return data.value
    }
  }
  getPayload() {

    var payload = {
      interestEnhancement: {
        tierSettings: this.tierSettings
      },
      ...this.data
    }
    return payload;
  }
}

const mapStateToProps = state => {
  let poolAccounts = []
  const { location = {}, notionalPooling = {} } = (state.sowEntities && state.sowEntities.selectedSowProduct) || {}
  if (state.sowEntities.allAccounts) {
    poolAccounts = state.sowEntities.allAccounts
  }
  return {
    // accounts: state.currentProductInterestEnhancement.accounts,
    countries: state.currentProductInterestEnhancement.countries,
    data: state.currentProductInterestEnhancement.data,
    // data: _interestEnhancement,
    customer: state.auth.userDetails,
    accounts: poolAccounts,
    lang: state.lang
  }
}


const mapDispatchToProps = dispatch => {
  return {
    setInterestEnhancementCurrency: currencies => {
      dispatch(setInterestEnhancementCurrency(currencies));
    },
    setDeletedtTierIndex: deletedIndex => {
      dispatch(setDeletedtTierIndex(deletedIndex));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IETireSetting);



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/InterestEnhancementSummary/IETireSetting/index.js